export const SORT_TYPES = [{
    value: '1',
    viewValue: 'Newest'
},
{
    value: '2',
    viewValue: 'Oldest'
},
];